import { lazy, useEffect, useState } from 'react'
import { Loader, NVButton } from '@nv/basic-components'
import { Attachments, useNVModal } from '@nv/components'
import FileIcon from '@nv/images/design/file-icon'
import { AdminVoterAuthService, VoterAuthService } from '@nv/services'
import { isAdmin, isViewOnlyEventHelpManagement } from '@nv/utils'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import styles from './AdminEventAttachments.module.scss'
const EventAttach = lazy(() => import('@nv/lazy-loadable/lib/modals/EventAttach'))

export const AdminEventAttachments = () => {
  const { t } = useTranslation()
  const { eventId } = useParams()
  const [listOfDocs, setListOfDocs] = useState([])
  const [loading, setLoading] = useState(true)
  const { NVModal, openModal } = useNVModal()

  const viewOnly = isViewOnlyEventHelpManagement()

  const getAttachments = async () => {
    try {
      let attachments
      if (isAdmin()) attachments = await AdminVoterAuthService.getHelpDocsEvent(eventId)
      else attachments = await VoterAuthService.getHelpDocsEvent(eventId)
      if (attachments) setListOfDocs(attachments)
    } catch (error) {
      //console.log(error)
    }
    setLoading(false)
  }

  useEffect(() => {
    getAttachments()
  }, [eventId])

  const onSubmitUpload = async (formData, eventId = null) => {
    return await AdminVoterAuthService.createHelpDocEvent(formData, eventId)
  }

  if (loading) return <Loader />

  return (
    <>
      {!viewOnly && (
        <NVModal>
          <EventAttach eventId={eventId} getAttachments={getAttachments} onSubmitUpload={onSubmitUpload} />
        </NVModal>
      )}

      <div className={styles['container']}>
        <div className={styles['header']}>
          <h1>{t('uploads.attachments')}</h1>
          {!viewOnly && (
            <NVButton
              variant='primaryGrey'
              onClick={() => openModal()}
              height={40}
              text={t('uploads.document.add')}
              icon={<FileIcon color={'var(--primary-color)'} />}
            />
          )}
        </div>

        {/* Attachments */}
        <Attachments listOfDocs={listOfDocs} getAttachments={getAttachments} viewOnly={viewOnly} />
      </div>
    </>
  )
}
